import { render, staticRenderFns } from "./MultimediaButtonMock.vue?vue&type=template&id=12c23d00&scoped=true&"
import script from "./MultimediaButtonMock.vue?vue&type=script&lang=ts&"
export * from "./MultimediaButtonMock.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12c23d00",
  null
  
)

export default component.exports